import { useQuery, useQueryClient, useMutation } from '@tanstack/react-query';
import { Card, Button } from '@getpay93/ui';
import { api } from '../lib/api';
import { qk } from '../data/queryKeys';

export function Notificaciones() {
  const qc = useQueryClient();
  const list = useQuery({ queryKey: qk.notifications, queryFn: () => api.notifications.list() });
  const markAll = useMutation({
    mutationFn: () => api.notifications.markAllRead(),
    onSuccess: () => { qc.invalidateQueries({ queryKey: qk.notifications }); qc.invalidateQueries({ queryKey: qk.unreadCount }); },
  });

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <h2 style={{ margin: 0, fontSize: 18, fontWeight: 800, color: 'var(--text-strong)' }}>Notificaciones</h2>
        <Button variant="ghost" size="sm" onClick={() => markAll.mutate()}>Marcar todas leídas</Button>
      </div>
      {list.isLoading ? <p style={{ color: 'var(--text-hint)' }}>Cargando…</p> : null}
      {list.data && list.data.length === 0 ? <Card><p style={{ margin: 0, color: 'var(--text-hint)' }}>Sin notificaciones.</p></Card> : null}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        {(list.data ?? []).map((n) => (
          <Card key={n.id} padding={14} style={n.readAt ? undefined : { borderLeft: '3px solid var(--brand-green)' }}>
            <div style={{ fontWeight: 700, color: 'var(--text-strong)' }}>{n.title}</div>
            <div style={{ color: 'var(--text-muted)', fontSize: 14 }}>{n.body}</div>
          </Card>
        ))}
      </div>
    </div>
  );
}
